import { Grid, Typography } from '@material-ui/core'
import { Variant } from '@material-ui/core/styles/createTypography'

const Message = ({
  message,
  variant
}: {
  message: string
  variant?: Variant
}) => (
  <Grid container alignItems='center'>
    <Grid item>
      <Typography variant={variant || 'h6'}>{message}</Typography>
    </Grid>
  </Grid>
)

export default Message
